import InputNumber, { InputNumberContainer } from '@deprecated-ui/common/InputNumber';
import numeral from 'numeral';
import { InputContainer, Label } from './styled';

interface TargetPriceInputNumberProps {
  price: number;
  onChangePrice: (val: any) => any;
}

function TargetPriceInputNumber({ price, onChangePrice }: TargetPriceInputNumberProps) {
  const handleChangePrice = (val) => {
    // update redux targetPrice
    const data = {
      target_price: val,
    };
    onChangePrice(data);
  };

  return (
    <InputContainer>
      <Label>is</Label>
      <InputNumberContainer>
        <InputNumber
          step={1}
          max="9007199254740991"
          min="0"
          formatter={(value) => numeral(value).format('0,0')}
          parser={(value) => value.replace(',', '')}
          style={{ width: '200px', textAlign: 'center' }}
          value={price}
          onChange={handleChangePrice}
        />
      </InputNumberContainer>
    </InputContainer>
  );
}

export default TargetPriceInputNumber;
